import { ArrowRight } from 'lucide-react'
import Link from 'next/link'
import type { PropsWithChildren } from 'react'
import { buttonVariants } from '~/components/ui/button'
import { Card } from '~/components/ui/card'
import { Skeleton } from '~/components/ui/skeleton'
import { cn } from '~/lib/utils'

export interface DashboardCardProps {
	isLoading?: boolean
	title: string
	subtitle?: string
	className?: string
	childrenClassName?: string
	footerClassName?: string
	link?: {
		label: string
		href: string
		onClick?: VoidFunction
	}
}

export const DashboardCard = ({
	isLoading,
	children,
	className,
	childrenClassName,
	footerClassName,
	title,
	subtitle,
	link,
}: PropsWithChildren<DashboardCardProps>) => (
	<Card
		className={cn('col-span-1 flex flex-col gap-y-4 p-6 max-md:p-4', className)}
	>
		<header>
			<div className='font-bold'>
				{isLoading ? <Skeleton className='h-[18px] w-3/4' /> : title}
			</div>

			{!!subtitle && (
				<div className='text-sm'>
					{isLoading ? <Skeleton className='mt-2 h-[14px] w-1/2' /> : subtitle}
				</div>
			)}
		</header>

		<div
			className={cn(
				'flex w-full flex-1 flex-col justify-center',
				childrenClassName,
			)}
		>
			{isLoading ? <Skeleton className='h-[50px] w-[150px]' /> : children}
		</div>

		{!!link && (
			<footer className={cn('text-right', footerClassName)}>
				{isLoading ? (
					<Skeleton className='ml-auto h-[14px] w-1/2' />
				) : (
					<Link
						href={link.href}
						className={buttonVariants({ variant: 'textPrimary' })}
						onClick={link.onClick}
					>
						{link.label}

						<ArrowRight
							size={20}
							className='ml-2 text-primary'
						/>
					</Link>
				)}
			</footer>
		)}
	</Card>
)
